// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  subscriptionButtonDetails: Object,
};

const DeleteSubscriptionButton = (props: Props) => {
  const {
    visible,
    close,
    submit,
    subscriptionButtonDetails,
  } = props;

  const deleteSelectedSubscriptionButton = () => {
    submit(subscriptionButtonDetails.gid);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={deleteSelectedSubscriptionButton} type="danger">Deactivate</SpButton>,
      ]}
      title="Deactivate Subscription Button"
    >
      <div className="px-4">
        <h6 className="mt-1 mb-2">Are you sure you want to deactivate this Subscription Button?</h6>
        <SpH5 className="pb-3">
          <div>{subscriptionButtonDetails.description ? subscriptionButtonDetails.description : <>&#8211;</>}</div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeleteSubscriptionButton;
